import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';

export const fetchCampaignByIdQuery = gql`
  query getCampaignById($id: Long!) {
    campaign(id: $id) {
      name
      id
      messageMedium
      templateId
      campaignState
    }
  }
`;

export const useGetCampaignResourceData = (id: number) => {
  const {
    data = {},
    isLoading,
    error,
  } = useGraphql(fetchCampaignByIdQuery, {
    variables: { id },
  });

  return {
    resource: data?.campaign || {},
    isLoading,
    hasError: !!error,
  };
};
